export const WX_EVENT = {
    // 微信获取签名是否成功
    WX_SIGNATURE_STATUS: 'wx_singature_status'
}
